// extracted by mini-css-extract-plugin
module.exports = {"OtherFeatures":"otherFeatures_OtherFeatures__bKpeQ"};